/**
 * Component for rendering audio content
 */

import { IconButton, Delete, IconSize, Spinner } from '@soteria/design-system-ve';

import * as styles from './AudioContentRenderer.css';

interface AudioContentRendererProps {
  audioUrl: string;
  hasError?: boolean;
  isLoading?: boolean;
  onClear: () => void;
}

/**
 * Renders an audio player with a clear button
 * Shows a loading spinner when the audio is being uploaded
 * Includes a track element for captions to address accessibility issues
 */
export function AudioContentRenderer({ audioUrl, hasError = false, isLoading = false, onClear }: AudioContentRendererProps) {
  const containerClass = hasError ? styles.audioContainerError : styles.audioContainer;

  return (
    <div className={containerClass}>
      {isLoading ? (
        <div className={styles.loadingContainer}>
          <Spinner />
        </div>
      ) : (
        <audio controls className={styles.audioPreview} src={audioUrl}>
          {/* Adding a track element to address accessibility requirement */}
          <track kind="captions" label="Audio description" />
        </audio>
      )}
      {!isLoading && <IconButton icon={Delete} iconSize={IconSize.XSmall} title="Remove audio" onClick={onClear} />}
    </div>
  );
}
